import React from "react";

import { SectionCard, TextArea } from "@amphore-dev/amphore-lib";
import { useFormikContext } from "formik";
import { t } from "i18next";

import { TInvoiceFormValues } from "@/types";

import { useInvoiceForm } from "./InvoiceFormContext";

/** Free text printed at the bottom of the invoice. */
export const InvoiceNotesCard: React.FC<{ className?: string }> = ({
	className,
}) => {
	const { values, setFieldValue } = useFormikContext<TInvoiceFormValues>();
	const { isLocked, isBusy } = useInvoiceForm();

	if (isLocked && !values.notes) return null;

	return (
		<SectionCard title={t("invoices.form.notes")} className={className}>
			<TextArea
				aria-label={t("invoices.form.notes")}
				placeholder={t("invoices.form.notesPlaceholder")}
				value={values.notes}
				onChange={(value) => setFieldValue("notes", value)}
				disabled={isLocked || isBusy}
				rows={3}
			/>
		</SectionCard>
	);
};
